import { defineMessages } from "react-intl";

export const messages = defineMessages({
    jsmUseCaseHeroTabsItSupportHeading: {
        id: "jsm-use-case-hero-tabs.it-support.heading",
        defaultMessage: "IT support"
    },
    jsmUseCaseHeroTabsItSupportAlt: {
        id: "jsm-use-case-hero-tabs.it-support.alt",
        defaultMessage:
            "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests."
    },
    jsmUseCaseHeroTabsItSupportUsp1: {
        id: "jsm-use-case-hero-tabs.it-support.usp1",
        defaultMessage: "Spin up a service desk with ease"
    },
    jsmUseCaseHeroTabsItSupportUsp2: {
        id: "jsm-use-case-hero-tabs.it-support.usp2",
        defaultMessage: "Manage all your requests in one place"
    },
    jsmUseCaseHeroTabsItSupportUsp3: {
        id: "jsm-use-case-hero-tabs.it-support.usp3",
        defaultMessage: "Automate support interactions with AI"
    },
    jsmUseCaseHeroTabsEngineeringSupportHeading: {
        id: "jsm-use-case-hero-tabs.engineering-support.heading",
        defaultMessage: "Engineering support"
    },
    jsmUseCaseHeroTabsEngineeringSupportAlt: {
        id: "jsm-use-case-hero-tabs.engineering-support.alt",
        defaultMessage:
            "A service project with options to see your queue, raise a request or see a knowledge base. One request is open. Its title is ‘unhelpful error message’ and has details about who raised the request and what it’s about, as well as any linked requests. "
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp1: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp1",
        defaultMessage: "Triage your unplanned work"
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp2: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp2",
        defaultMessage: "Manage customer requests"
    },
    jsmUseCaseHeroTabsEngineeringSupportUsp3: {
        id: "jsm-use-case-hero-tabs.engineering-support.usp3",
        defaultMessage: "Link requests to Jira issues"
    },
    jsmUseCaseHeroTabsEmployeeSupportHeading: {
        id: "jsm-use-case-hero-tabs.employee-support.heading",
        defaultMessage: "Employee support"
    },
    jsmUseCaseHeroTabsEmployeeSupportAlt: {
        id: "jsm-use-case-hero-tabs.employee-support.alt",
        defaultMessage:
            "A request portal with buttons for each company function to enter their part of the portal. For example, ‘human resources - employee help’ and ‘Facilities - book an event’."
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp1: {
        id: "jsm-use-case-hero-tabs.employee-support.usp1",
        defaultMessage: "Ensure anyone can get help quickly"
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp2: {
        id: "jsm-use-case-hero-tabs.employee-support.usp2",
        defaultMessage: "Empower employees with self-service"
    },
    jsmUseCaseHeroTabsEmployeeSupportUsp3: {
        id: "jsm-use-case-hero-tabs.employee-support.usp3",
        defaultMessage:
            "Deflect requests and save time with an AI-powered Virtual Service Agent"
    },
    jsmUseCaseHeroTabsItOperationHeading: {
        id: "jsm-use-case-hero-tabs.it-operation.heading",
        defaultMessage: "IT operations"
    },
    jsmUseCaseHeroTabsItOperationAlt: {
        id: "jsm-use-case-hero-tabs.it-operation.alt",
        defaultMessage:
            "A request called ‘Access service on staging’ with requestor name (Andrew) and details about the request. There is also a risk summary and an option to either ‘decline’ or ‘authorize’ Andrew’s request."
    },
    jsmUseCaseHeroTabsItOperationUsp1: {
        id: "jsm-use-case-hero-tabs.it-operations.usp1",
        defaultMessage: "Automate change requests"
    },
    jsmUseCaseHeroTabsItOperationUsp2: {
        id: "jsm-use-case-hero-tabs.it-operations.usp2",
        defaultMessage: "Deploy with confidence"
    },
    jsmUseCaseHeroTabsItOperationUsp3: {
        id: "jsm-use-case-hero-tabs.it-operations.usp3",
        defaultMessage: "Detect, resolve, and prevent incidents with AI"
    },
    jsmUseCaseHeroTabsHrServiceHeading: {
        id: "jsm-use-case-hero-tabs.hr-service.heading",
        defaultMessage: "HR service"
    },
    jsmUseCaseHeroTabsHrServiceAlt: {
        id: "jsm-use-case-hero-tabs.hr-service.alt",
        defaultMessage:
            "A example company HR help center with a search bar at the top and a list of categories below. Categories include ‘Software licensing’, ‘Travel and events’, and ‘Career Growth’."
    },
    jsmUseCaseHeroTabsHrServiceUsp1: {
        id: "jsm-use-case-hero-tabs.hr-service.usp1",
        defaultMessage: "Customize your help center"
    },
    jsmUseCaseHeroTabsHrServiceUsp2: {
        id: "jsm-use-case-hero-tabs.hr-service.usp1",
        defaultMessage: "Get started fast, with prebuilt templates"
    },
    jsmUseCaseHeroTabsHrServiceUsp3: {
        id: "jsm-use-case-hero-tabs.hr-service.usp3",
        defaultMessage:
            "Automate employee support with the virtual service agent"
    }
});
